import React from 'react';

import { QuestionSingleChoice, QuestionTypeV2 } from '../../../redux/types';
import ChoiceQuestionEditor from '../ChoiceQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionSingleChoice;
  addQuestion?: (dq: Omit<QuestionSingleChoice, 'id'>) => void
  updateQuestion?: (dq: QuestionSingleChoice) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
}

const SingleChoiceQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
}: Props) => (
  <ChoiceQuestionEditor<QuestionSingleChoice>
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    type={QuestionTypeV2.SingleChoice}
    disableHideAggregation={disableHideAggregation}
  />
);

export default SingleChoiceQuestionEditor;
